import { render, staticRenderFns } from "./instagramPost.vue?vue&type=template&id=49714dc1&scoped=true&"
import script from "./instagramPost.vue?vue&type=script&lang=js&"
export * from "./instagramPost.vue?vue&type=script&lang=js&"
import style0 from "./instagramPost.vue?vue&type=style&index=0&id=49714dc1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49714dc1",
  null
  
)

component.options.__file = "instagramPost.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VCardActions,
  VCardTitle,
  VFlex,
  VLayout,
  VSpacer,
  VTextField,
  VTextarea,
})
